import script from "./PurchaseDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseDetails.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseDetails.vue?vue&type=style&index=0&id=84a77bdc&scoped=true&lang=css"

import exportComponent from "/home/web/mintit-agency/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84a77bdc"]])

export default __exports__